import { Button, Form, FormInstance, Input, Select, Space, message } from "antd";
import React, { useEffect, useState } from "react";
import {
  editBranchTerms,
  fetchAllBranches,
  fetchUserPermissions,
} from "../../../../apis/branch.api";
import { usePermissions } from "../../../../custom_hooks/permission/permission_hook";
const { Option } = Select;

export interface BranchTermsEditProps {
  terms: any;
  closeDrawer: Function;
  letUpdate: Function;
}

const BranchTermsEditForm = ({
  terms,
  closeDrawer,
  letUpdate,
}: BranchTermsEditProps) => {
  const [form] = Form.useForm();
  const { hasPermission } = usePermissions();
  const canEdit = hasPermission("branch_details.update");
  const [permissions, setPermissions] = useState([]);
  const [branches, setBranches] = useState<any[]>([]);

  useEffect(() => {
    fetchUserPermissions().then((result: any) => {
      setPermissions(result);
    });
    fetchAllBranches().then((result: any) => {
      setBranches(result);
    });
  }, []);
  const onFinish = (updatedValues: any) => {
    if (!canEdit) {
      message.error("You don't have permission to edit terms");
      return;
    }
    editBranchTerms(terms?.id, updatedValues, updatedValues?.branch).then(
      () => {
        letUpdate();
        closeDrawer();
      }
    );
  };

  const SubmitButton = ({ form }: { form: FormInstance }) => {
    const [submittable, setSubmittable] = React.useState(false);

    const values = Form.useWatch([], form);

    React.useEffect(() => {
      form.validateFields({ validateOnly: true }).then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        }
      );
    }, [values]);

    return (
      <Button type="primary" htmlType="submit" disabled={!submittable}>
        Submit
      </Button>
    );
  };

  useEffect(() => {
    Object.keys(terms).map((key: any) => {
      form.setFieldValue(key, terms[key]);
    });
  }, [terms]);

  return (
    <Form
      form={form}
      name="validateOnly"
      layout="vertical"
      autoComplete="off"
      onFinish={onFinish}
    >
      <Form.Item
        name="title"
        label="Title"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="branch"
        label="Branch"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select
          placeholder="Select branch"
          options={branches?.map((branch) => ({
            label: branch?.branch_name,
            value: branch?.id,
          }))}
        />
      </Form.Item>
      <Form.Item
        name="description"
        label="Description"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item>
        <Space>
          <SubmitButton form={form} />
          <Button htmlType="reset">Reset</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default BranchTermsEditForm;
